module.exports = __webpack_public_path__ + "static/media/cashout-mockup.96edec66.webp";